import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { RatingsDueRequest } from './request';
import { getRatingsDue } from './request';

export const useRatingsDueQuery = (
  params: RatingsDueRequest,
  settings?: QuerySettings<typeof getRatingsDue>
) =>
  useQuery({
    queryKey: ['RatingsDue', params.artistProfileId],
    queryFn: () =>
      getRatingsDue({
        params,
        config: settings?.config
      }),
    // sensible defaults — override with settings.options
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 1000 * 60 * 5,
    ...settings?.options
  });
